<template>
  <form v-if="production" class="prod-stack" @submit.prevent="onSave">
    <div v-if="production.completed_at" class="prod-banner prod-banner--done">
      <span class="material-icons">task_alt</span>
      Completed {{ formatDateTime(production.completed_at) }}
    </div>
    <div class="move-card prod-panel space-y-5">
      <ProductionSectionHead title="Completed" subtitle="Close the production line once it has shipped." />
      <div class="move-field !mb-0">
        <label for="completion-notes">Completion notes</label>
        <textarea id="completion-notes" v-model="form.completion_notes" rows="4" class="move-textarea" />
      </div>
      <div v-if="publishedLinks.length" class="space-y-2">
        <p class="text-sm font-semibold move-text">Published links</p>
        <div class="flex flex-wrap gap-2">
          <a
            v-for="item in publishedLinks"
            :key="item.key"
            :href="item.url"
            target="_blank"
            rel="noopener"
            class="prod-link-chip"
          >
            {{ item.label }}
            <span class="material-icons">open_in_new</span>
          </a>
        </div>
      </div>
      <p v-if="message" class="prod-success">{{ message }}</p>
      <div class="prod-form-actions">
        <button type="submit" class="move-btn-ghost">Save notes</button>
        <button type="button" class="move-btn-primary" @click="markComplete">Mark completed</button>
      </div>
    </div>
  </form>
</template>

<script setup>
import { computed, inject, reactive, ref, watch } from 'vue'
import ProductionSectionHead from '../../components/production/ProductionSectionHead.vue'
import { platformLabels } from '../../config/productionNavigation'
import { formatDateTime } from '../../utils/productionDates'

const workspace = inject('productionWorkspace')
const production = workspace.production
const message = ref('')
const form = reactive({ completion_notes: '' })
const publishedLinks = computed(() => Object.entries(production.value?.release_links || {})
  .filter(([, url]) => url)
  .map(([key, url]) => ({
    key,
    url,
    label: platformLabels[key] || key
  })))

watch(production, (value) => {
  form.completion_notes = value?.completion_notes || ''
}, { immediate: true })

async function onSave () {
  await workspace.save({ completion_notes: form.completion_notes || null })
  message.value = 'Notes saved.'
}

async function markComplete () {
  await workspace.save({
    status: 'completed',
    completion_notes: form.completion_notes || null
  })
  message.value = 'Production marked completed.'
}
</script>
